import { useMutation } from '@tanstack/react-query';
import { UpdateSurveyRequestBody } from 'types';
import { updateSurveyData } from 'api/survey';

const useServerUpdateSurvey = () => {
  return useMutation((payload: UpdateSurveyRequestBody) => updateSurveyData({ ...payload }));
};
export default useServerUpdateSurvey;
